import PropTypes from 'prop-types';
import FlightItinerary from '../../../../TravelOption/FlightInformation/FlightItinerary';
import FlightInfo from '../../../../TravelOption/FlightInformation/FlightItinerary/FlightInfo';
import InvalidFlightTooltip from '../../../../ToolTip/InvalidFlightToolTip';

const FlightCompareTable = ({ flightTravelOptions, doShowViewButtonColumn, doShowPrice }) =>
  flightTravelOptions &&
  flightTravelOptions.map((travelOption) => (
    <>
      {travelOption.flightItinerary.isIncompleteItinerary && (
        <InvalidFlightTooltip placement="right" />
      )}
      {!doShowViewButtonColumn ? (
        <div className="my-3 rounded-lg sm:p-3 p-2 border-2" key={travelOption.itineraryId}>
          <FlightInfo itinerary={travelOption.flightItinerary} doShowPrice={doShowPrice} />
        </div>
      ) : (
        <FlightItinerary
          itinerary={travelOption.flightItinerary}
          key={travelOption.itineraryId}
          doShowPrice={doShowPrice}
        />
      )}
    </>
  ));

FlightCompareTable.propTypes = {
  flightTravelOptions: PropTypes.arrayOf(PropTypes.objectOf).isRequired,
  doShowViewButtonColumn: PropTypes.bool,
  doShowPrice: PropTypes.bool,
};

FlightCompareTable.defaultProps = {
  doShowViewButtonColumn: true,
  doShowPrice: true,
};

export default FlightCompareTable;
